import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Box, Typography } from "@mui/material";

// Register Chart.js components with error handling
try {
  ChartJS.register(ChartDataLabels); // Register the plugin
  ChartJS.register(ArcElement, Tooltip, Legend);
} catch (error) {
  console.warn("Chart.js registration warning:", error);
}

const PieChart = ({ labels, dataset, customWidth, customHeight, hide }) => {
  const data = {
    labels: labels ? labels : ["Red", "Blue","#eb7e0e"],
    datasets: dataset
      ? dataset
      : [
          {
            data: [0, 0],
            backgroundColor: ["#FF4C4C", "#007BFF","#eb7e0e"],
            borderColor: "#ffffff",
            borderWidth: 2,
            offset: [0, 20],
          },
        ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        titleColor: "white",
        bodyColor: "white",
      },
      datalabels: {
        color: "white", // Set label font color inside pie slices to white
        font: {
          weight: "bold", // Make the label text bold
        },
        formatter: (value, context) => {
          const total = context.chart.data.datasets[0].data.reduce(
            (acc, val) => acc + val,
            0
          );
          return total ? `${((value / total) * 100).toFixed(1)}%` : "0%";
        },
      },
    },
  };

  return (
    <div
      style={{
        width: customWidth ? customWidth : 200,
        height: customHeight ? customHeight : 200,
        marginBottom: "0.5rem",
      }}
    >
      {labels?.length > 0 && dataset?.length > 0 ? (
        <Pie data={data} options={options} />
      ) : (
        !hide && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center", // horizontally center
              alignItems: "center", // vertically center
              height: customHeight || "18rem", // ensure it takes up space
              width: customWidth || "100%", // optional, to match parent
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontFamily: "inter",
                color: "#d3d3d3",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </Typography>
          </Box>
        )
      )}
    </div>
  );
};

export default PieChart;
